var _path, _g, _rect, _rect2, _g2, _rect3, _rect4, _g3, _g4, _g5, _rect5, _rect6, _g6, _rect7, _rect8, _g7, _g8, _g9, _g10, _g11, _path2, _g12, _path3, _path4, _g13, _g14, _path5, _path6, _path7, _path8, _path9, _path10, _g15, _g16, _g17, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLinkTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 236,
    viewBox: "0 0 224 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.877 43.5469C123.013 46.2682 130.264 56.6681 140.972 60.7602C154.433 65.9039 173.759 58.8971 182.341 70.4728C190.597 81.6089 181.899 97.7589 178.334 111.155C175.43 122.067 168.876 131.033 163.572 141.002C158.063 151.355 156.099 164.375 146.46 171.055C136.688 177.828 123.763 177.114 111.877 176.83C100.199 176.55 88.766 174.479 78.2366 169.422C67.1642 164.103 55.96 157.623 49.7838 147.005C43.6012 136.376 45.5332 123.394 44.3442 111.155C43.0273 97.6014 37.01 83.5491 42.4036 71.045C47.8927 58.3195 60.3367 49.3053 73.2229 44.2048C85.4126 39.38 99.1416 40.4349 111.877 43.5469Z",
    fill: "var(--color-primary-active)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_60920_3000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_60920_3000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.5498,
    y: 76.4372,
    width: 61.3725,
    height: 75.4041,
    rx: 2.21163,
    fill: "var(--color-primary-70)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.0791,
    y: 83.1364,
    width: 55.683,
    height: 66.7762,
    rx: 6.70455,
    fill: "#5E6480"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.2354,
    y: 82.892,
    width: 54.0058,
    height: 64.8165,
    rx: 6.70455,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_60920_3000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.2646,
    y: 71.3751,
    width: 43.9413,
    height: 9.9678,
    rx: 1.84302,
    fill: "var(--color-primary-60)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.69
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.58,
    x: 81.0938,
    y: 95.3896,
    width: 10.9983,
    height: 10.9491,
    rx: 1.47442,
    fill: "#C4DBFF"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6816,
    y: 94.873,
    width: 10.8945,
    height: 10.8458,
    rx: 1.47442,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.3916,
    y: 96.6295,
    width: 7.41866,
    height: 7.38547,
    fill: "url(#pattern0_60920_3000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5684 97.9041L82.5995 97.6882C82.6176 97.5643 82.6752 97.4496 82.7645 97.3618L83.1992 96.9316C83.2812 96.8505 83.3891 96.8014 83.5037 96.7932L83.7232 96.7772L83.5707 96.8582C83.4373 96.929 83.3144 97.0178 83.2049 97.1216L82.9191 97.3938C82.8226 97.4858 82.7411 97.5916 82.6768 97.7078L82.5684 97.9041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4308 98.78L88.4296 96.8236L88.5868 96.8169L88.5458 96.9739L86.5812 98.9298L86.3213 98.9432L86.4308 98.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7894 100.751L82.79 102.707L82.6328 102.714L82.6738 102.557L84.6384 100.601L84.8989 100.587L84.7894 100.751Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_60920_3000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.2744,
    y: 96.0099,
    width: 29.5709,
    height: 2.9955,
    rx: 0.73721,
    fill: "#E5EBFF"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_60920_3000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.3984,
    y: 101.261,
    width: 23.3981,
    height: 2.9955,
    rx: 0.73721,
    fill: "#E5EBFF"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.69
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.58,
    x: 80.7266,
    y: 110.135,
    width: 10.9983,
    height: 10.9491,
    rx: 1.47442,
    fill: "#C4DBFF"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80.3096,
    y: 109.618,
    width: 10.8945,
    height: 10.8458,
    rx: 1.47442,
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.0186,
    y: 111.374,
    width: 7.41866,
    height: 7.38547,
    fill: "url(#pattern1_60920_3000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1963 112.649L82.2274 112.433C82.2456 112.309 82.3032 112.194 82.3924 112.106L82.8271 111.676C82.9091 111.595 83.017 111.546 83.1317 111.538L83.3511 111.522L83.1986 111.603C83.0653 111.674 82.9423 111.763 82.8328 111.866L82.547 112.139C82.4505 112.23 82.369 112.336 82.3047 112.453L82.1963 112.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0587 113.524L88.0576 111.568L88.2148 111.561L88.1738 111.718L86.2091 113.674L85.9492 113.687L86.0587 113.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4144 115.497L82.415 117.452L82.2578 117.459L82.2988 117.303L84.2634 115.346L84.5239 115.333L84.4144 115.497Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.69
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.58,
    x: 80.7266,
    y: 125.247,
    width: 10.9983,
    height: 10.9491,
    rx: 1.47442,
    fill: "#C4DBFF"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 80.3096,
    y: 124.731,
    width: 10.8945,
    height: 10.8458,
    rx: 1.47442,
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.0186,
    y: 126.487,
    width: 7.41866,
    height: 7.38547,
    fill: "url(#pattern2_60920_3000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1963 127.761L82.2274 127.545C82.2456 127.421 82.3032 127.306 82.3924 127.218L82.8271 126.788C82.9091 126.707 83.017 126.658 83.1317 126.65L83.3511 126.634L83.1986 126.715C83.0653 126.786 82.9423 126.875 82.8328 126.978L82.547 127.251C82.4505 127.342 82.369 127.448 82.3047 127.565L82.1963 127.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0587 128.637L88.0576 126.68L88.2148 126.674L88.1738 126.831L86.2091 128.786L85.9492 128.8L86.0587 128.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4144 130.609L82.415 132.564L82.2578 132.571L82.2988 132.415L84.2634 130.458L84.5239 130.445L84.4144 130.609Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_60920_3000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.2744 111.861C94.2744 111.454 94.6045 111.124 95.0116 111.124H123.108C123.515 111.124 123.845 111.454 123.845 111.861V113.382C123.845 113.789 123.515 114.119 123.108 114.119H95.0116C94.6045 114.119 94.2744 113.789 94.2744 113.382V111.861Z",
    fill: "#E5EBFF"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_60920_3000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3984 117.111C97.3984 116.704 97.7285 116.374 98.1356 116.374H120.059C120.467 116.374 120.797 116.704 120.797 117.111V118.632C120.797 119.039 120.467 119.369 120.059 119.369H98.1356C97.7285 119.369 97.3984 119.039 97.3984 118.632V117.111Z",
    fill: "#E5EBFF"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_60920_3000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.2744 126.604C94.2744 126.197 94.6045 125.866 95.0116 125.866H123.108C123.515 125.866 123.845 126.197 123.845 126.604V128.125C123.845 128.532 123.515 128.862 123.108 128.862H95.0116C94.6045 128.862 94.2744 128.532 94.2744 128.125V126.604Z",
    fill: "#E5EBFF"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_60920_3000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_60920_3000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3984 131.855C97.3984 131.448 97.7285 131.118 98.1356 131.118H120.059C120.467 131.118 120.797 131.448 120.797 131.855V133.376C120.797 133.783 120.467 134.113 120.059 134.113H98.1356C97.7285 134.113 97.3984 133.783 97.3984 133.376V131.855Z",
    fill: "#E5EBFF"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.19 163.129C144.54 163.129 155.363 152.355 155.363 139.064C155.363 125.774 144.54 115 131.19 115C117.84 115 107.018 125.774 107.018 139.064C107.018 152.355 117.84 163.129 131.19 163.129Z",
    fill: "url(#paint0_radial_60920_3000)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60920_3000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.669 126.783C140.709 123.823 135.893 123.823 132.933 126.783L128.522 131.194C127.752 131.963 127.129 132.945 126.727 134.144C126.72 134.147 126.714 134.15 126.707 134.152C125.793 136.903 126.486 139.894 128.522 141.93C129.131 142.538 129.846 143.039 130.622 143.409L130.908 143.123C131.898 142.133 131.898 140.534 130.908 139.544C129.262 137.898 129.262 135.226 130.908 133.579L135.319 129.168C136.965 127.522 139.637 127.522 141.284 129.168C142.93 130.815 142.93 133.487 141.284 135.133L137.934 138.482C138.381 139.863 138.476 141.325 138.259 142.749C138.612 142.503 138.952 142.237 139.258 141.93L143.669 137.519C146.63 134.559 146.63 129.743 143.669 126.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.489 135.965C133.88 135.357 133.165 134.856 132.377 134.498L132.103 134.772C131.113 135.763 131.113 137.361 132.103 138.351C133.749 139.997 133.749 142.67 132.103 144.316C130.709 145.709 129.009 147.409 127.681 148.738C126.035 150.384 123.363 150.384 121.716 148.738C120.07 147.092 120.07 144.42 121.716 142.773L125.077 139.413C124.63 138.032 124.535 136.57 124.752 135.146C124.399 135.392 124.059 135.658 123.752 135.965L119.33 140.388C116.37 143.348 116.37 148.164 119.33 151.124C122.291 154.084 127.106 154.084 130.067 151.124L134.489 146.702C135.258 145.932 135.882 144.95 136.284 143.751C136.291 143.749 136.297 143.745 136.304 143.743C137.218 140.992 136.525 138.002 134.489 135.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.646 147.894L140.453 146.701C140.123 146.372 139.59 146.372 139.26 146.701C138.93 147.031 138.93 147.565 139.26 147.894L140.453 149.087C140.783 149.417 141.316 149.417 141.646 149.087C141.975 148.758 141.975 148.224 141.646 147.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.751 130.001L122.558 128.808C122.229 128.478 121.695 128.478 121.365 128.808C121.036 129.138 121.036 129.671 121.365 130.001L122.558 131.194C122.888 131.523 123.422 131.523 123.751 131.194C124.081 130.864 124.081 130.33 123.751 130.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.76 141.626L143.13 141.189C142.68 141.068 142.218 141.335 142.097 141.785C141.977 142.238 142.246 142.699 142.694 142.819L144.323 143.256C144.774 143.376 145.236 143.109 145.357 142.659C145.476 142.209 145.21 141.744 144.76 141.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.319 135.076L118.689 134.64C118.239 134.519 117.776 134.786 117.656 135.236C117.535 135.689 117.805 136.15 118.252 136.269L119.882 136.706C120.332 136.827 120.795 136.56 120.915 136.11C121.035 135.659 120.767 135.194 120.319 135.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.813 151.765L135.377 150.136C135.255 149.684 134.793 149.419 134.343 149.539C133.893 149.66 133.626 150.122 133.747 150.573L134.184 152.202C134.303 152.65 134.764 152.919 135.217 152.799C135.667 152.678 135.934 152.216 135.813 151.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.265 127.322L128.828 125.693C128.708 125.241 128.245 124.977 127.794 125.096C127.344 125.217 127.077 125.679 127.198 126.13L127.635 127.759C127.674 127.907 127.751 128.035 127.853 128.137C128.059 128.343 128.366 128.436 128.668 128.356C129.118 128.235 129.385 127.773 129.265 127.322Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.97 86.4481C193.742 86.4481 193.556 86.2652 193.553 86.0341C193.553 85.803 193.736 85.6136 193.967 85.6104C194.246 85.6071 194.529 85.6039 194.808 85.6039C195.039 85.6039 195.225 85.7901 195.225 86.0212C195.225 86.2523 195.039 86.4385 194.808 86.4385C194.529 86.4385 194.252 86.4385 193.976 86.4449H193.97V86.4481Z",
    fill: "#4B90DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.846 110.766C177.618 110.766 177.432 110.583 177.429 110.355C177.426 110.124 177.608 109.932 177.84 109.928C178.119 109.922 178.401 109.919 178.684 109.919C178.915 109.919 179.101 110.105 179.101 110.336C179.101 110.567 178.915 110.753 178.684 110.753C178.408 110.753 178.132 110.753 177.856 110.763C177.856 110.763 177.849 110.763 177.846 110.763V110.766Z",
    fill: "#4B90DA"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.343 30.7184C180.231 30.6928 180.128 30.6221 180.061 30.5194C179.926 30.3076 179.99 30.0283 180.202 29.8935L183.531 27.7975C183.743 27.6626 184.022 27.73 184.157 27.9387C184.291 28.1505 184.227 28.4298 184.015 28.5646L180.687 30.6607C180.581 30.7281 180.459 30.7441 180.343 30.7184Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.539 29.7683C178.344 29.7234 178.196 29.5532 178.186 29.3446L178.036 25.4189C178.026 25.1686 178.218 24.9567 178.472 24.9471C178.716 24.9471 178.934 25.1333 178.941 25.3836L179.092 29.3093C179.101 29.5597 178.909 29.7683 178.658 29.7779C178.616 29.7779 178.578 29.7779 178.539 29.7683Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.816 30.8532C176.777 30.8436 176.742 30.834 176.707 30.8147L173.231 28.9851C173.009 28.8663 172.926 28.5935 173.041 28.372C173.157 28.1505 173.433 28.0735 173.651 28.1794L177.127 30.0123C177.349 30.131 177.435 30.4039 177.317 30.6253C177.22 30.8115 177.012 30.8982 176.816 30.8564V30.8532Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.568 34.9875C173.456 34.9618 173.353 34.8944 173.285 34.7885C173.151 34.5767 173.215 34.2974 173.427 34.1626L176.752 32.0665C176.964 31.9317 177.243 31.9959 177.378 32.2078C177.513 32.4196 177.449 32.6989 177.237 32.8337L173.911 34.9297C173.805 34.9972 173.684 35.0132 173.571 34.9875H173.568Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.851 37.7705C178.655 37.7256 178.508 37.5554 178.498 37.3468L178.347 33.4211C178.337 33.1708 178.53 32.9621 178.784 32.9493C179.031 32.9493 179.243 33.1355 179.252 33.3858L179.403 37.3115C179.413 37.5619 179.217 37.7705 178.967 37.7801C178.928 37.7801 178.886 37.7801 178.848 37.7705H178.851Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.9 34.5863C183.862 34.5767 183.826 34.5638 183.788 34.5446L180.315 32.7117C180.09 32.5962 180.006 32.3233 180.125 32.0986C180.241 31.8772 180.523 31.8001 180.735 31.9093L184.208 33.7389C184.43 33.8576 184.516 34.1305 184.398 34.352C184.301 34.5381 184.093 34.628 183.897 34.5831L183.9 34.5863Z",
    fill: "#4B90DA"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35408 92.8583C7.24173 92.8326 7.13902 92.762 7.07161 92.6593C6.9368 92.4474 7.00099 92.1681 7.21284 92.0333L10.5415 89.9373C10.7533 89.8025 11.0326 89.8699 11.1674 90.0785C11.3022 90.2904 11.238 90.5696 11.0262 90.7044L7.69754 92.8005C7.59161 92.8679 7.46964 92.8839 7.35408 92.8583Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5502 91.9081C5.35439 91.8632 5.20674 91.6931 5.19711 91.4844L5.04624 87.5588C5.03661 87.3084 5.22921 87.0965 5.48279 87.0869C5.72674 87.0869 5.94501 87.2731 5.95143 87.5235L6.10229 91.4491C6.11192 91.6995 5.91933 91.9081 5.66896 91.9178C5.62723 91.9178 5.58871 91.9178 5.5502 91.9081Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82673 92.9931C3.78821 92.9834 3.7529 92.9706 3.7176 92.9546L0.241305 91.1249C0.0198247 91.0062 -0.0636306 90.7333 0.0519246 90.5118C0.16748 90.2904 0.443526 90.2133 0.661797 90.3193L4.13809 92.1521C4.35957 92.2709 4.44302 92.5437 4.32747 92.7652C4.23117 92.9514 4.02253 93.038 3.82673 92.9963V92.9931Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.578689 97.1274C0.466344 97.1017 0.363627 97.0343 0.296219 96.9252C0.161405 96.7133 0.225603 96.4341 0.437454 96.2992L3.76288 94.2032C3.97473 94.0684 4.25399 94.1326 4.3888 94.3444C4.52362 94.5563 4.45942 94.8356 4.24757 94.9704L0.922142 97.0664C0.816217 97.1338 0.694243 97.1499 0.581897 97.1242L0.578689 97.1274Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86172 99.9103C5.66592 99.8654 5.51826 99.6953 5.50863 99.4866L5.35777 95.561C5.34814 95.3106 5.54073 95.102 5.7943 95.0891C6.04146 95.0891 6.25332 95.2753 6.26295 95.5256L6.41382 99.4513C6.42345 99.7017 6.22764 99.9103 5.97727 99.92C5.93875 99.92 5.89702 99.92 5.85851 99.9103H5.86172Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9108 96.7294C10.8723 96.7197 10.837 96.7069 10.7985 96.6876L7.32538 94.8548C7.10069 94.7392 7.01724 94.4664 7.136 94.2417C7.25156 94.0202 7.53081 93.9432 7.74587 94.0523L11.219 95.882C11.4404 96.0007 11.5271 96.2736 11.4083 96.495C11.312 96.6812 11.1034 96.7711 10.9076 96.7261L10.9108 96.7294Z",
    fill: "#4B90DA"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.247 75.3227C153.134 75.297 153.032 75.2264 152.964 75.1237C152.829 74.9119 152.894 74.6326 153.105 74.4978L156.434 72.4017C156.646 72.2701 156.925 72.3343 157.06 72.543C157.195 72.7548 157.131 73.0341 156.919 73.1689L153.59 75.2649C153.484 75.3323 153.362 75.3484 153.247 75.3227Z",
    fill: "var(--color-primary-50)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.443 74.3726C151.247 74.3277 151.099 74.1575 151.09 73.9489L150.939 70.0232C150.929 69.7729 151.122 69.561 151.375 69.5514C151.619 69.5514 151.838 69.7376 151.844 69.9879L151.995 73.9136C152.005 74.164 151.812 74.3726 151.562 74.3822C151.52 74.3822 151.481 74.3822 151.443 74.3726Z",
    fill: "var(--color-primary-50)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.715 75.4608C149.677 75.4512 149.642 75.4415 149.606 75.4223L146.13 73.5926C145.909 73.4739 145.825 73.201 145.941 72.9796C146.056 72.7581 146.332 72.681 146.55 72.787L150.027 74.6198C150.248 74.7386 150.332 75.0114 150.216 75.2329C150.12 75.4191 149.911 75.5057 149.715 75.464V75.4608Z",
    fill: "var(--color-primary-50)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.47 79.5919C146.358 79.5662 146.255 79.4988 146.188 79.3897C146.053 79.1778 146.117 78.8985 146.329 78.7637L149.654 76.6677C149.866 76.5329 150.146 76.5971 150.28 76.8089C150.415 77.0208 150.351 77.3 150.139 77.4348L146.814 79.5309C146.708 79.5983 146.586 79.6143 146.474 79.5887L146.47 79.5919Z",
    fill: "var(--color-primary-50)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.75 82.3748C151.555 82.3299 151.407 82.1598 151.397 81.9511L151.246 78.0254C151.237 77.7751 151.429 77.5664 151.683 77.5536C151.93 77.5536 152.142 77.7398 152.152 77.9901L152.302 81.9158C152.312 82.1662 152.116 82.3748 151.866 82.3844C151.827 82.3844 151.786 82.3844 151.747 82.3748H151.75Z",
    fill: "var(--color-primary-50)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.799 79.1938C156.761 79.1842 156.726 79.1714 156.687 79.1521L153.214 77.3193C152.989 77.2037 152.906 76.9309 153.025 76.7062C153.14 76.4847 153.423 76.4077 153.635 76.5168L157.108 78.3464C157.329 78.4652 157.416 78.738 157.297 78.9595C157.201 79.1457 156.992 79.2356 156.796 79.1906L156.799 79.1938Z",
    fill: "var(--color-primary-50)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.079 109.784C185.966 109.758 185.864 109.688 185.796 109.582C185.661 109.37 185.726 109.091 185.937 108.956L189.266 106.86C189.478 106.725 189.757 106.792 189.892 107.001C190.027 107.213 189.963 107.492 189.751 107.627L186.422 109.723C186.316 109.79 186.194 109.806 186.079 109.781V109.784Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.276 108.834C184.08 108.789 183.932 108.619 183.923 108.41L183.772 104.484C183.762 104.234 183.955 104.022 184.208 104.013C184.452 104.013 184.671 104.199 184.677 104.449L184.828 108.375C184.837 108.625 184.645 108.834 184.395 108.843C184.353 108.843 184.314 108.843 184.276 108.834Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.548 109.919C182.51 109.909 182.475 109.899 182.439 109.88L178.963 108.051C178.741 107.932 178.658 107.659 178.774 107.437C178.889 107.216 179.165 107.139 179.383 107.245L182.86 109.078C183.081 109.196 183.165 109.469 183.049 109.691C182.953 109.877 182.744 109.964 182.548 109.922V109.919Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.303 114.053C179.191 114.027 179.088 113.96 179.021 113.854C178.886 113.642 178.95 113.363 179.162 113.228L182.487 111.132C182.699 110.997 182.979 111.061 183.113 111.273C183.248 111.485 183.184 111.764 182.972 111.899L179.647 113.995C179.541 114.063 179.419 114.079 179.306 114.053H179.303Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.583 116.836C184.388 116.791 184.24 116.621 184.23 116.412L184.079 112.487C184.07 112.236 184.262 112.028 184.516 112.015C184.763 112.015 184.975 112.201 184.985 112.451L185.136 116.377C185.145 116.627 184.949 116.836 184.699 116.846C184.66 116.846 184.619 116.846 184.58 116.836H184.583Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.632 113.652C189.594 113.642 189.559 113.629 189.52 113.61L186.047 111.777C185.822 111.662 185.739 111.389 185.858 111.164C185.973 110.943 186.252 110.866 186.468 110.975L189.941 112.804C190.162 112.923 190.249 113.196 190.13 113.417C190.034 113.604 189.825 113.693 189.629 113.649L189.632 113.652Z",
    fill: "#4B90DA"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.991 84.7052L197.427 80.7281L223.635 82.561L199.991 84.7052Z",
    fill: "#F9A200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.991 91.2276V84.7052L223.635 82.561L199.991 91.2276Z",
    fill: "#F98200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.089 86.6921L203.968 91.5069L223.635 82.561L201.089 86.6921Z",
    fill: "#F9A200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.991 91.2276L201.089 86.6921L203.114 90.0817L199.991 91.2276Z",
    fill: "#E75E22"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.18 30.3525C38.0338 29.091 38.8877 27.8006 39.7447 26.475C31.0074 27.0848 22.2734 24.0323 13.5361 24.6421C21.4164 25.3579 29.2998 29.0557 37.18 30.3525Z",
    fill: "#F9A200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.18 36.875V30.3525C29.2998 29.0557 21.4164 25.358 13.5361 24.6422C21.4164 27.531 29.2998 33.4019 37.18 36.875Z",
    fill: "#F98200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0822 32.2431C35.1225 33.7517 34.1659 35.2251 33.2062 36.6792C26.6484 32.6668 20.0939 27.6209 13.5361 24.6422C21.0504 26.0192 28.5679 30.1086 36.0822 32.2431Z",
    fill: "#F9A200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1798 36.8749C36.8139 35.3374 36.448 33.7934 36.0821 32.2463C35.408 33.3087 34.7307 34.3519 34.0566 35.3855C35.0998 35.9152 36.1398 36.4159 37.1798 36.8749Z",
    fill: "#E75E22"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5767 111.328C28.4147 111.328 27.4678 110.381 27.4678 109.219C27.4678 108.057 28.4147 107.11 29.5767 107.11C30.7386 107.11 31.6855 108.057 31.6855 109.219C31.6855 110.381 30.7386 111.328 29.5767 111.328ZM29.5767 107.945C28.8737 107.945 28.3023 108.516 28.3023 109.219C28.3023 109.922 28.8737 110.493 29.5767 110.493C30.2796 110.493 30.851 109.922 30.851 109.219C30.851 108.516 30.2796 107.945 29.5767 107.945Z",
    fill: "#E75E22"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9312 4.21776C81.7692 4.21776 80.8223 3.27085 80.8223 2.10888C80.8223 0.946911 81.7692 0 82.9312 0C84.0931 0 85.04 0.946911 85.04 2.10888C85.04 3.27085 84.0931 4.21776 82.9312 4.21776ZM82.9312 0.834567C82.2282 0.834567 81.6568 1.40592 81.6568 2.10888C81.6568 2.81184 82.2282 3.3832 82.9312 3.3832C83.6341 3.3832 84.2055 2.81184 84.2055 2.10888C84.2055 1.40592 83.6341 0.834567 82.9312 0.834567Z",
    fill: "#E75E22"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.3228 87.119C43.1608 87.119 42.2139 86.1721 42.2139 85.0101C42.2139 83.8482 43.1608 82.9012 44.3228 82.9012C45.4847 82.9012 46.4316 83.8482 46.4316 85.0101C46.4316 86.1721 45.4847 87.119 44.3228 87.119ZM44.3228 83.739C43.6198 83.739 43.0484 84.3104 43.0484 85.0133C43.0484 85.7163 43.6198 86.2877 44.3228 86.2877C45.0257 86.2877 45.5971 85.7163 45.5971 85.0133C45.5971 84.3104 45.0257 83.739 44.3228 83.739Z",
    fill: "var(--color-primary)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.874 131.704C177.712 131.704 176.765 130.757 176.765 129.595C176.765 128.433 177.712 127.486 178.874 127.486C180.036 127.486 180.986 128.433 180.986 129.595C180.986 130.757 180.039 131.704 178.874 131.704ZM178.874 128.324C178.171 128.324 177.602 128.895 177.602 129.595C177.602 130.295 178.174 130.866 178.874 130.866C179.573 130.866 180.148 130.295 180.148 129.595C180.148 128.895 179.576 128.324 178.874 128.324Z",
    fill: "#232374"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.185 27.8745C63.0231 27.8745 62.0762 26.9276 62.0762 25.7656C62.0762 24.6037 63.0231 23.6567 64.185 23.6567C65.347 23.6567 66.2939 24.6037 66.2939 25.7656C66.2939 26.9276 65.347 27.8745 64.185 27.8745ZM64.185 24.4913C63.4821 24.4913 62.9107 25.0627 62.9107 25.7656C62.9107 26.4686 63.4821 27.0399 64.185 27.0399C64.888 27.0399 65.4594 26.4686 65.4594 25.7656C65.4594 25.0627 64.888 24.4913 64.185 24.4913Z",
    fill: "#4B90DA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M204.809 108.901C203.647 108.901 202.7 107.954 202.7 106.792C202.7 105.63 203.647 104.683 204.809 104.683C205.971 104.683 206.918 105.63 206.918 106.792C206.918 107.954 205.971 108.901 204.809 108.901ZM204.809 105.518C204.106 105.518 203.538 106.089 203.538 106.792C203.538 107.495 204.109 108.067 204.809 108.067C205.509 108.067 206.08 107.495 206.08 106.792C206.08 106.089 205.509 105.518 204.809 105.518Z",
    fill: "#4B90DA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.27392 42.9031C8.11195 42.9031 7.16504 41.9562 7.16504 40.7942C7.16504 39.6322 8.11195 38.6853 9.27392 38.6853C10.4359 38.6853 11.3828 39.6322 11.3828 40.7942C11.3828 41.9562 10.4359 42.9031 9.27392 42.9031ZM9.27392 39.5199C8.57096 39.5199 7.99961 40.0912 7.99961 40.7942C7.99961 41.4971 8.57096 42.0685 9.27392 42.0685C9.97688 42.0685 10.5482 41.4971 10.5482 40.7942C10.5482 40.0912 9.97688 39.5199 9.27392 39.5199Z",
    fill: "#FFBC2D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M172.987 11.2313C171.825 11.2313 170.878 10.2844 170.878 9.12243C170.878 7.96046 171.825 7.01355 172.987 7.01355C174.149 7.01355 175.099 7.96046 175.099 9.12243C175.099 10.2844 174.152 11.2313 172.987 11.2313ZM172.987 7.85133C172.284 7.85133 171.713 8.42268 171.713 9.12564C171.713 9.8286 172.284 10.4 172.987 10.4C173.69 10.4 174.261 9.8286 174.261 9.12564C174.261 8.42268 173.69 7.85133 172.987 7.85133Z",
    fill: "#FFBC2D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_60920_3000",
    x: 32.8524,
    y: 46.9318,
    width: 139.454,
    height: 139.455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.68182
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.34091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_60920_3000",
    x: 70.4071,
    y: 76.4003,
    width: 63.6574,
    height: 77.6894,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.571337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_60920_3000",
    x: 64.1748,
    y: 69.7326,
    width: 76.1221,
    height: 90.1541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.670455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.68605,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_innerShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.42326
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.73721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_60920_3000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_60920_3000",
    x: 77.6844,
    y: 66.9518,
    width: 49.1019,
    height: 15.1282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.29012
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_60920_3000",
    x: 80.2646,
    y: 71.3751,
    width: 43.9414,
    height: 10.3364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.368605,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.571337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_60920_3000",
    x: 82.2442,
    y: 96.6295,
    width: 7.71383,
    height: 7.90148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.073721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_60920_3000",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_60920_3000",
    transform: "scale(0.00699301)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_60920_3000",
    x: 94.2744,
    y: 96.0099,
    width: 29.5713,
    height: 3.36409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.258023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_60920_3000",
    x: 94.2744,
    y: 96.0099,
    width: 29.5713,
    height: 2.99548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_60920_3000",
    x: 97.3984,
    y: 101.261,
    width: 23.3984,
    height: 3.36409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.258023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_60920_3000",
    x: 97.3984,
    y: 101.261,
    width: 23.3984,
    height: 2.99548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_60920_3000",
    x: 81.8711,
    y: 111.374,
    width: 7.71383,
    height: 7.90148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.073721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_60920_3000",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_60920_3000",
    transform: "scale(0.00699301)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_60920_3000",
    x: 81.8711,
    y: 126.487,
    width: 7.71383,
    height: 7.90154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.073721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_60920_3000",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_60920_3000",
    transform: "scale(0.00699301)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_60920_3000",
    x: 94.2744,
    y: 111.124,
    width: 29.5713,
    height: 3.36409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.258023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_60920_3000",
    x: 94.2744,
    y: 111.124,
    width: 29.5713,
    height: 2.99548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_60920_3000",
    x: 97.3984,
    y: 116.374,
    width: 23.3984,
    height: 3.36409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.258023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_60920_3000",
    x: 97.3984,
    y: 116.374,
    width: 23.3984,
    height: 2.99548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_60920_3000",
    x: 94.2744,
    y: 125.866,
    width: 29.5713,
    height: 3.36409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.258023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_60920_3000",
    x: 94.2744,
    y: 125.866,
    width: 29.5713,
    height: 2.99548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_60920_3000",
    x: 97.3984,
    y: 131.118,
    width: 23.3984,
    height: 3.36409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.368605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.258023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_60920_3000",
    x: 97.3984,
    y: 131.118,
    width: 23.3984,
    height: 2.99548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_60920_3000",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.19 139.064) scale(24.1727 24.0645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FCA841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F59A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#EA813C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#DA5F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C63333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD2031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60920_3000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7813,
    height: 28.7813,
    fill: "white",
    transform: "translate(117.11 124.563)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_60920_3000",
    width: 143,
    height: 143,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLinkTask);
export default __webpack_public_path__ + "static/media/NoLinkTask.01826ad8a1dd5641de9564a64c0f5046.svg";
export { ForwardRef as ReactComponent };